import React from 'react';
import DocsHelper from 'util/DocsHelper';

const DocumentationLink = React.createClass({
  propTypes: {
    page: React.PropTypes.string.isRequired,
    text: React.PropTypes.node.isRequired,
    title: React.PropTypes.string,
  },
  render() {
    return (
      <a href={DocsHelper.toString(this.props.page)} title={this.props.title} target="_blank">
        {this.props.text}
      </a>
    );
  },
});

export default DocumentationLink;



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/src/components/support/DocumentationLink.jsx